// //////////////////////////////
// USER ROLE TYPES
export enum UserRoleTypes {
    Developer = 0,
    Administrator = 1,
    TechSupport = 2,
    Sales = 3,
    Training = 4,
}

// //////////////////////////////////
// USER ROLE ACCESS TYPES
export enum RoleAccessTypes {
    Restricted = 0,
    Read = 1,
    Write = 2
}


// /////////////////////////////////////////////////
// COMPONENT TYPES FOR USER ROLE ACCESS RESTRICTIONS
export enum ComponentTypes {

    MemberDelete = 0,
    MemberMerge = 1,
    MemberEdit = 2,

    ProductDelete = 10,
    ProductAdd = 11,
    ProductTransfer = 12,

    CreditDelete = 20,
    CreditAdd = 21,

    NavShowDev = 100,
    NavShowAdmin = 101,

}

export class UserRoleItem {
    Role: UserRoleTypes;
    Access: RoleAccessItemArray;
}

export class UserRoleItemArray extends Array<UserRoleItem> {

    constructor(...items: UserRoleItem[]) {
        super(...items);
        Object.setPrototypeOf(this, UserRoleItemArray.prototype);
    }


}

export class RoleAccessItem {

    Component: ComponentTypes;
    Access: RoleAccessTypes;

}

export class RoleAccessItemArray extends Array<RoleAccessItem> {

    constructor(...items: RoleAccessItem[]) {
        super(...items);
        Object.setPrototypeOf(this, RoleAccessItemArray.prototype);
    }


}
